import { Link } from 'react-router-dom'
import { Card } from '../ui/Card'
import { SectionLabel } from '../ui/SectionLabel'
import { Avatar } from '../ui/Avatar'
import { EmptyState } from '../ui/EmptyState'
import type { CotMePerson } from '../../types/community'

function statusLine(p: CotMePerson): string {
  if (p.online) return 'Online now'
  return 'Offline'
}

interface FamilyCardProps {
  people: CotMePerson[]
  accountHolderId: string
}

/** "Your family right now" card (COTC_FriendsApprovals R4 / DESIGN §3.1). Hidden for solo by the caller. */
export function FamilyCard({ people, accountHolderId }: FamilyCardProps) {
  const managed = people.filter((p) => p.id !== accountHolderId)

  return (
    <Card>
      <SectionLabel>Your family right now</SectionLabel>
      {managed.length === 0 ? (
        <EmptyState
          className="mt-2"
          description="Nobody added yet. Use the + beside Your Family to set up a profile you manage."
          action={<Link to="/onboard" className="text-[13px] font-medium text-terra-deep hover:text-terra-hover">Add a person</Link>}
        />
      ) : (
        <ul className="mt-3 space-y-3">
          {managed.map((p) => (
            <li key={p.id} className="flex items-center gap-3">
              <Avatar initials={(p.firstName || '?')[0].toUpperCase()} tintIndex={p.avatarTintIndex} showDot online={p.online} ringClass="border-paper-surface" size={30} />
              <div>
                <div className="text-[13.5px] font-medium text-ink">{p.firstName}</div>
                <div className="font-mono text-[10px] uppercase tracking-label text-ink-faint">{statusLine(p)}</div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </Card>
  )
}
